import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

export const Wrapper = styled("header")(() => ({
  marginBottom: "1.07rem",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",

  flexWrap: "wrap",
  gap: 8,
}));

export const WrapperLeftSide = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: "1rem",

  "@media screen and (max-width: 425px)": {
    width: "100%",
    justifyContent: "space-between",
  },
}));

export const InventoryButtonsContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  border: `1px solid ${colors.gray200}`,
  borderRadius: "8px",
  overflow: "hidden",
}));

export const InventoryButton = styled("div")(({ selected }: { selected?: boolean }) => ({
  backgroundColor: selected ? colors.brandBlue50 : colors.white,
  display: "flex",
  padding: "8px 12px",
  alignItems: "center",
  justifyContent: "center",
  minWidth: "95px",
  cursor: "pointer",
  "&:not(:last-child)": {
    borderRight: `1px solid ${colors.gray200}`,
  },
  "& span": {
    color: selected ? colors.brandBlue500 : colors.gray800,
    font: "600 14px Manrope",
    lineHeight: "20px",
    letterSpacing: "0.1px",
  },
}));
